import React from 'react';

/**
 * Komponen tabel reusable dengan styling responsive
 * @param {string} title - Judul tabel
 * @param {string[]} columns - Array nama kolom
 * @param {Object[]} data - Array data untuk ditampilkan
 * @param {boolean} isDarkMode - Status dark mode
 */
const TableComponent = ({ title, columns, data, isDarkMode }) => (
    <div className={`rounded border overflow-hidden mb-20 md:mb-0 ${isDarkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200'}`}>
        <div className={`px-4 py-3 border-b flex justify-between items-center bg-opacity-50 ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
            <h3 className="font-semibold text-sm">{title}</h3>
            <button className="text-xs bg-indigo-600 hover:bg-indigo-700 text-white px-2 py-1 rounded transition-colors">
                + Add New
            </button>
        </div>
        <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
                <thead>
                    <tr className={`text-[11px] uppercase tracking-wider ${isDarkMode ? 'bg-slate-700/50 text-slate-300' : 'bg-slate-50 text-slate-500'}`}>
                        {columns.map((col, idx) => (
                            <th
                                key={idx}
                                className={`px-4 py-3 font-medium border-b ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}
                            >
                                {col}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="text-xs">
                    {data.map((row, rIdx) => (
                        <tr
                            key={rIdx}
                            className={`border-b last:border-0 hover:bg-opacity-50 transition-colors ${isDarkMode ? 'border-slate-700 hover:bg-slate-700/30' : 'border-slate-100 hover:bg-slate-50'}`}
                        >
                            {Object.values(row).map((cell, cIdx) => (
                                <td key={cIdx} className="px-4 py-2.5">{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
);

export default TableComponent;
